import { ActionType } from 'app/store/actionTypes';
import { createAction, ActionsUnion } from 'app/store/helpers';
import { PriceBeforeRecalculationSetActionPayload } from './actionPayload.interfaces';

export const PriceBeforeRecalculationActions = {
  setPriceBeforeRecalculation: (
    payload: PriceBeforeRecalculationSetActionPayload
  ) => createAction(ActionType.SET_PRICE_BEFORE_RECALCULATION, payload),
  clearPriceBeforeRecalculation: () =>
    createAction(ActionType.CLEAR_PRICE_BEFORE_RECALCULATION),
};

export type PriceBeforeRecalculationActionsType = ActionsUnion<
  typeof PriceBeforeRecalculationActions
>;
